import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "rows"]

  connect() {
  }

  filter() {
    const filterValue = this.inputTarget.value.toLowerCase()
    const rows = this.rowsTarget.querySelectorAll('tr[data-alliance-table-search-target="row"]')
    rows.forEach(row => {
      const allianceName = row.cells[0].textContent.toLowerCase()
      const shouldShow = allianceName.includes(filterValue)
      row.style.display = shouldShow ? "" : "none"
    })
  }
}
